import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "components/Card/Card.jsx";
import contactosStyle from "assets/jss/material-dashboard-pro-react/views/contactosStyle.jsx";
import CardBody from "../../components/Card/CardBody";
import {GoogleMap, Marker, withGoogleMap, withScriptjs} from "react-google-maps";

function Contactos() {
  const CordilheiraMap = withScriptjs(
    withGoogleMap(props => {
      return <GoogleMap
        defaultZoom={16}
        defaultCenter={{lat: props.lat, lng: props.lon}}
        defaultOptions={{
          disableDefaultUI: true
        }}
        center={{lat: props.lat, lng: props.lon}}
      >
        <Marker position={{lat: props.lat, lng: props.lon}}/>
      </GoogleMap>
    })
  );

  return <>
    <Card style={{minHeight: "20px", overflow: "hidden"}}>
      <React.Fragment>
        <CordilheiraMap
          googleMapURL={"https://maps.googleapis.com/maps/api/js?key=" + process.env.MAPS_KEY + "&basemap=roadmap"}
          loadingElement={<div style={{height: `100%`}}/>}
          lat={38.7076158}
          lon={-9.1504641}
          containerElement={
            <div
              style={{
                height: "288px",
                borderRadius: "6px",
                overflow: "hidden"
              }}
            />
          }
          mapElement={<div style={{height: `100%`}}/>}
        />
      </React.Fragment>
    </Card>
    <Card style={{minHeight: "20px", overflow: "hidden"}}>
      <React.Fragment>
        <CardBody style={{textAlign: "center", padding: "6em 0"}}>
          <h3 style={{fontWeight: "400"}}>Corpo Nacional de Escutas</h3>
          <h3 style={{fontWeight: "400", marginTop: "0"}}>Plataforma Nacional de Gestão da Formação</h3>
          <h5 style={{fontStyle: "italic", fontWeight: "400"}}>Morada Rua D. Luís I nº34, 1200-152 Lisboa</h5>
          <h5 style={{fontStyle: "italic", fontWeight: "400"}}>Telefone 218 427 020</h5>
          <h5 style={{fontStyle: "italic", fontWeight: "400"}}>E-mail cordilheira.ajuda@escutismo.pt</h5>
        </CardBody>
      </React.Fragment>
    </Card>
  </>
}

export default withStyles(contactosStyle)(Contactos);
